/**
 * DLP APi
 * DLP Services
 *
 * OpenAPI spec version: 1.0
 * Contact: check
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs/Observable';

import { ReviewDto } from '../model/reviewDto';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class ReviewControllerService {

    protected basePath = 'https://localhost:8080/nrfsi/nissan';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * getReviewCustomerInfo
     * 
     * @param custId custId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getReviewCustomerInfoUsingGET(custId: string, observe?: 'body', reportProgress?: boolean): Observable<ReviewDto>;
    public getReviewCustomerInfoUsingGET(custId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ReviewDto>>;
    public getReviewCustomerInfoUsingGET(custId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ReviewDto>>;
    public getReviewCustomerInfoUsingGET(custId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (custId === null || custId === undefined) {
            throw new Error('Required parameter custId was null or undefined when calling getReviewCustomerInfoUsingGET.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<ReviewDto>(`${this.basePath}/review/previewInfo/${encodeURIComponent(String(custId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getReviewSubmitInfo
     * 
     * @param custId custId
     * @param portfolioId portfolioId
     * @param quotationId quotationId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getReviewSubmitInfoUsingGET(custId: string, portfolioId: number, quotationId: string, observe?: 'body', reportProgress?: boolean): Observable<ReviewDto>;
    public getReviewSubmitInfoUsingGET(custId: string, portfolioId: number, quotationId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ReviewDto>>;
    public getReviewSubmitInfoUsingGET(custId: string, portfolioId: number, quotationId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ReviewDto>>;
    public getReviewSubmitInfoUsingGET(custId: string, portfolioId: number, quotationId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (custId === null || custId === undefined) {
            throw new Error('Required parameter custId was null or undefined when calling getReviewSubmitInfoUsingGET.');
        }

        if (portfolioId === null || portfolioId === undefined) {
            throw new Error('Required parameter portfolioId was null or undefined when calling getReviewSubmitInfoUsingGET.');
        }

        if (quotationId === null || quotationId === undefined) {
            throw new Error('Required parameter quotationId was null or undefined when calling getReviewSubmitInfoUsingGET.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<ReviewDto>(`${this.basePath}/review/info/${encodeURIComponent(String(portfolioId))}/${encodeURIComponent(String(quotationId))}/${encodeURIComponent(String(custId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
